<template>
    <div>
        <div :class="{fadeIn: visible}" v-show="visible">
            <slot></slot>
        </div>
        <div v-show="!visible" style="height: 100px"></div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        visible: false
      };
    },
    props: {
        flag: {
            type: Boolean,
            default: false
        }
    },
    created() {
      window.addEventListener("scroll", this.handleScroll);
      window.addEventListener("onload", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("onload", this.handleScroll);
    },
    mounted() {
    },
    watch: {
        visible: function() {
            this.$emit('visible');
        },
        flag: function() {
            if(this.flag)
                this.visible = true;
        }
    },
    methods: {
      handleScroll() {
        if (!this.visible) {
          var top = this.$el.getBoundingClientRect().top;
          this.visible = top < window.innerHeight + 10;
        }
      }
    }
  }
</script>

<style scoped>
.mock {
    height: 100px;
}
.noneDisplay {
    display: none;
}
.fadeIn {
  animation: fadeIn 2s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>